import * as types from "../actions/actionTypes";

import initialState from "./initialState";
import { MentorUserInfo } from "../../../Shared/GeneratedTypes";

export default function userInfoReducer(state = initialState.userInfo, action: any): MentorUserInfo {
    if (action.type === types.GET_MENTOR_USER_INFO_SUCCESS) {
        return action.userInfo;
    }
    return state;
}
